import React, { useEffect, useState } from 'react';
import { extractApiError } from '../utils/errorUtils'; // Issue #964: Standardized error handling

const EmailTemplateGallery: React.FC = () => {
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  console.log('EmailTemplateGallery: Component mounted/rendered');

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        console.log('EmailTemplateGallery: Starting fetch...');
        setLoading(true);
        setError('');

        const apiUrl = `${import.meta.env.VITE_API_BASE_URL}/dev/email-templates`;
        const token = localStorage.getItem('access_token');

        console.log('EmailTemplateGallery: API URL:', apiUrl);
        console.log('EmailTemplateGallery: Token exists:', !!token);

        // Make authenticated request to backend endpoint
        const response = await fetch(apiUrl, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        console.log('EmailTemplateGallery: Response status:', response.status);

        if (!response.ok) {
          if (response.status === 401) {
            throw new Error('Authentication required. Please log in as an admin.');
          } else if (response.status === 403) {
            const data = await response.json();
            throw new Error(data.detail || 'Access forbidden. Admin access or feature flag required.');
          } else {
            throw new Error(`Failed to load email templates: ${response.statusText}`);
          }
        }

        const html = await response.text();

        // Inject token into the HTML so iframe JavaScript can use it
        const tokenScript = `
          <script>
            window.__AUTH_TOKEN__ = '${token}';
          </script>
        `;
        const htmlWithToken = html.replace('</head>', `${tokenScript}</head>`);

        setHtmlContent(htmlWithToken);
      } catch (err: unknown) {
        const apiError = extractApiError(err);
        setError(apiError.message);
        console.error('Error fetching email templates:', apiError);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading email templates...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center" style={{ minHeight: '400px' }}>
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
          <h2 className="text-red-800 font-semibold text-lg mb-2">Error Loading Templates</h2>
          <p className="text-red-600">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-white shadow-sm" style={{ height: 'calc(100vh - 180px)' }}>
      <iframe
        srcDoc={htmlContent}
        title="Email Template Gallery"
        className="w-full h-full border-0"
        sandbox="allow-same-origin allow-scripts"
      />
    </div>
  );
};

export default EmailTemplateGallery;
